import React from 'react';
import Icon from './Icon';
import { WHY_CHOOSE_US } from '../data/content';

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="section">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Why Buildstrust</span>
          <h2 className="section-title">A Strategic Partner, Not Just a Vendor</h2>
          <p className="section-subtitle">
            We combine deep technical expertise with business strategy to deliver results you can measure.
          </p>
        </div>

        <div className="why-grid">
          {WHY_CHOOSE_US.map((w, i) => (
            <div className="why-card reveal" key={w.title} style={{ transitionDelay: `${i * 0.06}s` }}>
              <div className="why-icon">
                <Icon name={w.icon} size={22} />
              </div>
              <div>
                <h4>{w.title}</h4>
                <p>{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}